module.exports = __webpack_public_path__ + "static/img/en.87933be1.png";